import React, {useEffect, useState} from "react";
import {Button, createStyles, FormControl, InputLabel, MenuItem, Select, TextField, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {produce} from "immer";
import {ServerApi} from "../ServerApi";
import {DictionaryGroup} from "../models/models";



const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		input: {
			marginBottom: "30px",
			height: 50
		}
	})
);



export const DictionaryManagerComponent: React.FC<any> = () => {
	const classes = useStyles();


	const [dictionaryGroups, setDictionaryGroups] = useState<DictionaryGroup[]>([]);
	const [dictionaryGroupName, setDictionaryGroupName] = useState("");
	const [selectedDictionaryGroupId, setSelectedDictionaryGroupId] = useState<number>(-1);
	const [dictionaryName, setDictionaryName] = useState("");


	useEffect(() => {
		ServerApi
			.getDictionaryGroups(true)
			.then(dgs => setDictionaryGroups(dgs));
	}, []);


	const handleCreateDictionaryGroup = (dictionaryGroupName: string) => {
		ServerApi
			.createDictionaryGroup(dictionaryGroupName)
			.then((dg) => {
				dg.dictionaries = [];
				setDictionaryGroups(dictionaryGroups.concat(dg));
				setDictionaryGroupName("");
			});
	};

	const handleUpdateDictionaryGroup = (dictionaryGroupId: number) => {
		const dictionaryGroup = dictionaryGroups.find(dg => dg.id === dictionaryGroupId)!;

		const newDictionaryGroupName = prompt("새로운 사전 그룹 이름을 입력해주세요.", dictionaryGroup.name)!;

		if (newDictionaryGroupName) {
			ServerApi.updateDictionaryGroup(dictionaryGroup.id, newDictionaryGroupName)
				.then(() => {
					const newDictionaryGroups = produce(dictionaryGroups, draft => {
						const dg = draft.find(dg => dg.id === dictionaryGroupId)!;
						dg.name = newDictionaryGroupName;
					});

					setDictionaryGroups(newDictionaryGroups);
				});
		}
	};


	const handleCreateDictionary = (dictionaryName: string, dictionaryGroupId: number) => {
		ServerApi
			.createDictionary(dictionaryName, dictionaryGroupId)
			.then((d) => {
				const newDictionaryGroups = produce(dictionaryGroups, draft => {
					d.count = 0;
					draft.find(dg => dg.id === d.dictionaryGroupId)!.dictionaries.push(d);
				});

				setDictionaryGroups(newDictionaryGroups);
				setDictionaryName("");
			});
	};

	const handleUpdateDictionary = (dictionaryId: number) => {
		const dictionary = dictionaryGroups
			.flatMap(dg => dg.dictionaries)
			.find(d => d.id === dictionaryId)!;

		const newDictionaryName = prompt("새로운 사전 이름을 입력해주세요.", dictionary.name)!;

		if (newDictionaryName) {
			ServerApi.updateDictionary(dictionary.id, newDictionaryName)
				.then(() => {
					const newDictionaryGroups = produce(dictionaryGroups, draft => {
						const d = draft
							.flatMap(dg => dg.dictionaries)
							.find(d => d.id === dictionaryId)!;

						d.name = newDictionaryName;
					});

					setDictionaryGroups(newDictionaryGroups);
				});
		}
	};


	return (
		<>
			<div>
				<TextField label="사전 그룹 이름"
				           style={{width: "200px"}}
				           InputProps={{className: classes.input}}
				           value={dictionaryGroupName}
				           variant="outlined"
				           onChange={(e) => setDictionaryGroupName(e.target.value)}/>

				<Button onClick={() => handleCreateDictionaryGroup(dictionaryGroupName)}
				        variant="contained"
				        className={classes.input}
				        color="primary">
					사전 그룹 추가
				</Button>
			</div>

			<FormControl variant="outlined" style={{width: "200px"}}>
				<InputLabel id="demo-simple-select-outlined-label">사전 그룹</InputLabel>
				<Select value={selectedDictionaryGroupId}
				        labelId="demo-simple-select-outlined-label"
				        className={classes.input}
				        onChange={(e) => setSelectedDictionaryGroupId(e.target.value as number)}
				        variant="outlined"
				        label="사전 그룹">
					{dictionaryGroups
						.map(dg =>
							<MenuItem key={dg.id} value={dg.id}>{dg.name}</MenuItem>
						)
					}
				</Select>
			</FormControl>

			<TextField label="사전 이름"
			           style={{width: "200px"}}
			           value={dictionaryName}
			           InputProps={{className: classes.input}}
			           variant="outlined"
			           onChange={(e) => setDictionaryName(e.target.value)}/>

			<Button onClick={() => handleCreateDictionary(dictionaryName, selectedDictionaryGroupId)}
			        variant="contained"
			        className={classes.input}
			        color="primary">
				사전 추가
			</Button>

			<div style={{display: "flex", flexWrap: "wrap"}}>
				{dictionaryGroups.map(dg =>
					<div key={dg.id}
					     style={{
						     border: "1px solid gray",
						     padding: "10px",
						     marginRight: "20px",
						     marginBottom: "20px",
						     width: "320px",
						     backgroundColor: "#eeeeee"
					     }}>
						<h2>
							{dg.name} ({dg.dictionaries.flatMap(d => d.count).reduce((acc, current) => acc + current, 0)}개)

							<Button color="primary" onClick={() => handleUpdateDictionaryGroup(dg.id)}>수정</Button>

							<form action="/Api/DictionaryGroup/Delete" method="post" style={{display: "inline"}}
							      onSubmit={e => {
								      if (!window.confirm("정말로 사전그룹을 삭제하시겠습니까?")) {
									      e.preventDefault();
								      }
							      }}>
								<input type="hidden" name="dictionaryGroupId" value={dg.id}/>
								<Button type="submit" color="secondary">삭제</Button>
							</form>
						</h2>

						<hr/>

						{dg.dictionaries?.map(d =>
							<h4 key={d.id}>
								{d.name} ({d.count}개)

								<Button color="primary" onClick={() => handleUpdateDictionary(d.id)}>수정</Button>

								<form action="/Api/Dictionary/Delete" method="post" style={{display: "inline"}}
								      onSubmit={e => {
									      if (!window.confirm("정말로 사전을 삭제하시겠습니까?")) {
										      e.preventDefault();
									      }
								      }}>
									<input type="hidden" name="dictionaryId" value={d.id}/>
									<Button type="submit" color="secondary">삭제</Button>
								</form>
							</h4>)}
					</div>
				)}
			</div>
		</>
	)
};